import { render, staticRenderFns } from "./PaddedContent.vue?vue&type=template&id=de7ba174&scoped=true&"
import script from "./PaddedContent.vue?vue&type=script&lang=ts&"
export * from "./PaddedContent.vue?vue&type=script&lang=ts&"
import style0 from "./PaddedContent.vue?vue&type=style&index=0&id=de7ba174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7ba174",
  null
  
)

export default component.exports